import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiBookOpen, FiHeadphones } from 'react-icons/fi';
import Section from './Section';

const cardGameItems = [
  'Egyptian Raskers',
  'Poker',
  'Dou Dizhu',
  'Speed',
];

const albumCovers = [
  {
    artist: 'ODESZA',
    album: 'The Last Goodbye',
    image: 'https://i.discogs.com/EhNmMOq5n15WexB3uA-AzfX7D-F6btbsSne5dkcQPKg/rs:fit/g:sm/q:40/h:150/w:150/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTE0OTg0/NTg1LTE3MTU4ODQ5/ODUtMzYxNi5qcGVn.jpeg'
  },
  {
    artist: 'Fred again..',
    album: 'Actual Life 3',
    image: 'https://i.scdn.co/image/ab67616d00001e026e2101520787791370f4a96b'
  },
  {
    artist: 'The Reaper',
    album: 'Unknown Album',
    image: 'https://raider-review.com/wp-content/uploads/2021/11/the_reaper.jpg'
  }
];

const AboutSection = () => {
  return (
    <Section id="about" className="section-dark Non-Hero">
      <Container style={{ position: 'relative', zIndex: 1 }}>
        <h2 className="section-title text-center">About Me</h2>
        <Row className="align-items-stretch justify-content-center g-5 about-equal">
          <Col xs={12} md={5} className="d-flex">
            <div className="about-photo-wrap flex-fill">
              {/* Replace src with your own headshot in /public, e.g. /me.jpg */}
              <img
                src="/Headshot.PNG"
                alt="Portrait"
                className="about-photo img-fluid"
              />
            </div>
          </Col>
          <Col xs={12} md={7} className="d-flex">
            <div className="about-card flex-fill">
              <div className="card-index top-left">
                <span>A</span>
                <span className="suit">♠</span>
              </div>
              <div className="card-index bottom-right">
                <span>A</span>
                <span className="suit">♠</span>
              </div>
              <div className="card-watermark">♠</div>
              <div className="about-card-content about-copy">
              <h5 className="about-lead">
                Hey, I'm Patrick. I code, I create, and I'm always curious about what's next.
              </h5>
              <p className="about-text">
                I want to build something great. I'm always trying to improve my craft and learn new skills. In my free time I like listening to music, rock climbing, and playing badminton and tennis. Also I've been interested in AI-powered tools!
              </p>
              <Row className="mt-3">
                <Col sm={12} md={6} className="mb-3">
                  <div className="about-list-title">
                    <FiBookOpen className="me-2" /> My favorite card games:
                  </div>
                  <ul className="about-list">
                    {cardGameItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </Col>
                <Col sm={12} md={6} className="mb-3">
                  <div className="about-list-title">
                    <FiHeadphones className="me-2" /> Currently listening to:
                  </div>
                  <div className="album-covers-grid">
                    {albumCovers.map((album, index) => (
                      <div key={index} className="album-card">
                        <div className="album-cover-center">
                          <img 
                            src={album.image} 
                            alt={`${album.artist} - ${album.album}`}
                            className="album-cover-image"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default AboutSection;
